import { lazy, Suspense } from 'react';
import { HairFrontNoBackList, MultiColorHairBackList, NoColorHairFrontList, SingleColorHairFrontList } from 'shared/types/optionSets';
import { getHighlightColor } from '../utils/HighlightColors';
import styled from '@emotion/styled';
import { HairBaseColors, HairHighlightColors } from 'shared/types/colorSets';
import NoSelection from 'shared/components/avatar/NoSelection';
import { getLayeredHairThumbnailViewStyle, HAIR_BACK_Z_INDEX, HAIR_FRONT_Z_INDEX, HAIR_THUMBNAIL_VIEWBOX } from '../utils/LayoutUtils';
import { lightGray, red } from 'shared/styles/colors';
import HeadLayer from './HeadLayer';
import EarsLayer from './EarsLayer';

interface Props {
  option: number;
  colorBase: string;
}

const HairThumbnailLayer = ({ option, colorBase }: Props) => {
  const viewBox = HAIR_THUMBNAIL_VIEWBOX;
  const hairFrontNoBackStyle = getLayeredHairThumbnailViewStyle(HAIR_FRONT_Z_INDEX);
  const hairFrontThumbStyle = getLayeredHairThumbnailViewStyle(HAIR_FRONT_Z_INDEX);
  const hairBackThumbStyle = getLayeredHairThumbnailViewStyle(HAIR_BACK_Z_INDEX);

  const hairFrontComponentName = option < 10 ? `HairFront0${option}` : `HairFront${option}`;
  const HairFrontComponent = lazy(() => import(`shared/components/avatar/hair/${hairFrontComponentName}`));

  const hairBackComponentName = option < 10 ? `HairBack0${option}` : `HairBack${option}`;
  const HairBackComponent = lazy(() => import(`shared/components/avatar/hair/${hairBackComponentName}`));

  const getHairHighlight = () => {
    return getHighlightColor(colorBase, HairBaseColors, HairHighlightColors);
  };

  if (option === 0) {
    return (
      <NoSelection />
    );
  }

  return (
    <Suspense fallback={<div />}>
      <Container>
        {NoColorHairFrontList.includes(option) && (
          <HairFrontComponent
            viewBoxProp={viewBox}
            colorBase={lightGray}
            style={HairFrontNoBackList.includes(option) ?
              hairFrontNoBackStyle : hairFrontThumbStyle}
          />
        )}
        {SingleColorHairFrontList.includes(option) ? (
          <HairFrontComponent
            viewBoxProp={viewBox}
            colorBase={colorBase}
            style={HairFrontNoBackList.includes(option) ?
              hairFrontNoBackStyle : hairFrontThumbStyle}
          />
        ) : (
          !NoColorHairFrontList.includes(option) &&
          <HairFrontComponent
            viewBoxProp={viewBox}
            colorBase={colorBase}
            colorHighlight={getHairHighlight()}
            style={HairFrontNoBackList.includes(option) ?
              hairFrontNoBackStyle : hairFrontThumbStyle}
          />
        )}
        {!HairFrontNoBackList.includes(option) &&
          (MultiColorHairBackList.includes(option) ? (
            <HairBackComponent
              viewBoxProp={viewBox}
              colorBase={colorBase}
              colorHighlight={getHairHighlight()}
              style={hairBackThumbStyle}
            />
          ) : (
            <HairBackComponent
              viewBoxProp={viewBox}
              colorBase={colorBase}
              style={hairBackThumbStyle}
            />
          ))}
        <HeadLayer
          colorBase={red}
          isThumbnail
          isHairThumbnail
        />
        <EarsLayer
          option={1}
          colorBase={red}
          isThumbnail
          isHairThumbnail
        />
      </Container>
    </Suspense>
  );
}

export default HairThumbnailLayer;

const Container = styled.div({
  width: '100%',
  height: 'auto',
  position: 'relative',
});
